import { useEffect, useState } from 'react';
import { getHistoriqueStatuts } from '../services/corbeilleService';

function dateHeure(iso) {
  const d = new Date(iso);
  return d.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Historique détaillé d'une entité : une ligne par changement de statut
 * (création, traitement, suppression, restauration…), avec l'auteur.
 * `entite` : code de l'entité (demande, devis, contrat, client…).
 */
function HistoriqueStatuts({ entite, id }) {
  const [lignes, setLignes] = useState(null);
  const [erreur, setErreur] = useState(null);

  useEffect(() => {
    let annule = false;
    setLignes(null);
    setErreur(null);
    getHistoriqueStatuts(entite, id)
      .then((res) => {
        if (!annule) setLignes(res.data || []);
      })
      .catch((err) => {
        if (!annule) setErreur(err.message || 'Historique indisponible.');
      });
    return () => {
      annule = true;
    };
  }, [entite, id]);

  if (erreur) return <div className="historique-statuts-vide">{erreur}</div>;
  if (!lignes) return <div className="historique-statuts-vide">Chargement…</div>;
  if (!lignes.length) return <div className="historique-statuts-vide">Aucun changement enregistré.</div>;

  return (
    <ol className="historique-statuts">
      {lignes.map((l) => (
        <li key={l.id} className={`historique-statuts-ligne historique-statuts-${l.statut}`}>
          <span className="historique-statuts-statut">{l.statutLibelle}</span>
          <span className="historique-statuts-meta">
            {dateHeure(l.dateHeure)} · {l.utilisateurNom || 'système'}
          </span>
          {l.commentaire && <span className="historique-statuts-commentaire">{l.commentaire}</span>}
        </li>
      ))}
    </ol>
  );
}

export default HistoriqueStatuts;
